var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0H0V13H17V0Z",
    fill: "#2f2f2f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3536 6.35355C13.5488 6.15829 13.5488 5.84171 13.3536 5.64645L10.1716 2.46447C9.97631 2.2692 9.65973 2.2692 9.46447 2.46447C9.2692 2.65973 9.2692 2.97631 9.46447 3.17157L12.2929 6L9.46447 8.82843C9.2692 9.02369 9.2692 9.34027 9.46447 9.53553C9.65973 9.7308 9.97631 9.7308 10.1716 9.53553L13.3536 6.35355ZM13 5.5L3 5.5V6.5L13 6.5V5.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowLight);
export default __webpack_public_path__ + "static/media/right-arrowLight.5f335c007279837657f1c0b15020880c.svg";
export { ForwardRef as ReactComponent };